import { useState, useMemo } from "react"; // Aggiunto useMemo
import CenterPad from "../../Components/CenterPad/CenterPad";
import Loadable from "../../Components/Loadable/Loadable";
import MultiForm from "../../Components/MultiForm/MultiForm";
import Generic from "../../Utils/Generic";
import Tr from "../../Utils/Translations/Translations";
import "./ContactUsPage.scss";
import { Link, useLocation } from "react-router-dom"; // Aggiunto useLocation
import { AppRoutes } from "../../AppRoutes";
import { Icon } from "@fluentui/react";
import { IFeedbackInsert } from "../../Models/IFeedback";
import ApiService from "../../Services/ApiService";
import { ToastMessage } from "../../Utils/UIMessages";
import { IAPIResponse } from "../../Services/AjaxService";
import { IContactUs } from "../../Models/IContactUs";

// Definizione interfaccia per le info del servizio
interface IServiceInfo {
  titleKey: string;
  descKey: string;
  icon: string;
}

const ContactUsPage = () => {
  const [done, setDone] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({});

  // 1. Hook per leggere la query string
  const location = useLocation();

  // 2. Mappa dei servizi basata sul parametro "about"
  // NOTA: Assicurati che i link nel Footer usino: ?about=support, ?about=teaching, ?about=private_solutions
  const serviceInfos: Record<string, IServiceInfo> = {
    support: {
      titleKey: "service_support_title",
      descKey: "service_support_desc",
      icon: "Headset", // Icona FluentUI
    },
    teaching: {
      titleKey: "service_teaching_title",
      descKey: "service_teaching_desc",
      icon: "Education",
    },
    private_solutions: {
      titleKey: "service_private_title",
      descKey: "service_private_desc",
      icon: "Shield",
    },
  };

  // 3. Estrazione del servizio corrente
  const currentServiceParam = new URLSearchParams(location.search).get("about");
  const currentService = currentServiceParam
    ? serviceInfos[currentServiceParam]
    : null;

  const sendFeedback = (data: any) => {
    setFormData(data);
    setLoading(true);
    let feedback: IContactUs = {
      Email: data.email,
      Message: data.message, // Qui potresti pre-appendere il servizio: `[${currentServiceParam}] ${data.message}`
      Language: Tr.GetLanguage(),
    };
    ApiService.SysController.AddContactUs(
      feedback,
      (response: IAPIResponse) => {
        if (response.error == null) {
          ToastMessage(
            "success",
            Tr.Translate("language", "action_completed_successfully")
          );
          setDone(true);
        } else {
          ToastMessage("error", Tr.Translate("system", "generic_api_failure"));
        }
        setLoading(false);
      }
    );
  };

  return (
    <div
      className="contact-us-page-wrap"
      style={Generic.GetRandomBackgroundUrlCss()}
    >
      <CenterPad
        content={
          <Loadable
            isLoading={loading}
            content={
              <div className="registration-inner-frame">
                {/* 4. SEZIONE DINAMICA SERVIZI */}
                {!done && currentService && (
                  <div className="service-intro-box">
                    <div className="service-icon">
                      <Icon iconName={currentService.icon} />
                    </div>
                    <div className="service-text">
                      <h3>
                        {Tr.Translate("presentation", currentService.titleKey)}
                      </h3>
                      <p>
                        {Tr.Translate("presentation", currentService.descKey)}
                      </p>
                    </div>
                  </div>
                )}

                {!done && (
                  <MultiForm
                    autoButton={Tr.Translate("presentation", "presentation_13")}
                    formUniqueId="loginForm"
                    onSubmit={sendFeedback}
                    inputs={[
                      {
                        type: "email",
                        name: "email",
                        currentValue: formData?.email,
                        label: Tr.Translate("language", "email"),
                        required: true,
                        extraParams: { maxLength: 50 },
                      },
                      {
                        type: "multiline",
                        name: "message",
                        currentValue: formData?.message,
                        label: Tr.Translate("language", "message"),
                        required: true,
                        extraParams: { maxLength: 1000 },
                      },
                    ]}
                  />
                )}
                {done && (
                  <div className="contact-us-done-icon">
                    <div>{Tr.Translate("language", "done")}</div>
                    <Icon iconName="SkypeCircleCheck" />
                  </div>
                )}
                <hr />
                <div className="flex-line">
                  <Link to={AppRoutes.HOME_PAGE}>
                    {Tr.Translate("language", "back")}
                  </Link>
                </div>
              </div>
            }
          />
        }
      />
    </div>
  );
};

export default ContactUsPage;
